import {
  buttonVariants,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@e2n/ui';
import { DesktopKalender } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop';
import { KalenderViewOptions } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/KalenderViewOptions';
import { YearNavigationHeader } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/YearNavigationHeader';
import { Uebersicht } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/Uebersicht';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { cn } from '@/lib/utils';
import {
  faLayerGroup,
  faPlusLarge,
  faUserGroup,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet, useNavigate } from 'react-router-dom';

/* eslint-disable max-lines-per-function */
export function DesktopPage({ view }: { view: string }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { store } = useRotationsplanFeatureContext();

  return (
    <div className="flex flex-col gap-8">
      <Tabs
        value={view}
        onValueChange={(value) => {
          navigate(`/mitarbeiter/rotationsplaene/${value}`, { replace: true });
        }}>
        <div className="flex w-full justify-between">
          <TabsList className="bg-neutrals-300">
            <TabsTrigger className="w-full" value="planung">
              {t('domain.mitarbeiter.rotationsplan.tabs.planung')}
            </TabsTrigger>
            <TabsTrigger className="w-full" value="uebersicht">
              {t('domain.mitarbeiter.rotationsplan.tabs.rotationsplaene')}
            </TabsTrigger>
          </TabsList>
          {view === 'uebersicht' && (
            <Link
              to={`/mitarbeiter/rotationsplaene/uebersicht/create`}
              replace
              className={cn(
                buttonVariants({ variant: 'default', size: 'icon' }),
              )}>
              <FontAwesomeIcon icon={faPlusLarge} />
            </Link>
          )}
        </div>

        <TabsContent className="mt-6" value="planung">
          <Tabs defaultValue="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
            <div className="flex flex-col gap-4 w-full min-h-125 bg-white rounded-md items-start justify-start p-4">
              <div className="w-full flex items-start justify-between">
                <div className="flex flex-col gap-2">
                  <YearNavigationHeader />
                  <KalenderViewOptions />
                </div>
                <TabsList>
                  <Tooltip>
                    <TooltipTrigger>
                      <TabsTrigger
                        onClick={() =>
                          store.setKalenderView('byArbeitsbereiche')
                        }
                        value="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
                        <FontAwesomeIcon fixedWidth icon={faLayerGroup} />
                      </TabsTrigger>
                    </TooltipTrigger>
                    <TooltipContent>
                      {t(
                        'domain.mitarbeiter.rotationsplan.tabs.anzeigeNachArbeitsbereichenTooltip',
                      )}
                    </TooltipContent>
                  </Tooltip>
                  <Tooltip>
                    <TooltipTrigger>
                      <TabsTrigger
                        onClick={() => store.setKalenderView('byMitarbeiter')}
                        value="mitarbeiter_rotationsplanKalenderByMitarbeiter">
                        <FontAwesomeIcon fixedWidth icon={faUserGroup} />
                      </TabsTrigger>
                    </TooltipTrigger>
                    <TooltipContent>
                      {t(
                        'domain.mitarbeiter.rotationsplan.tabs.anzeigeNachMitarbeitendenTooltip',
                      )}
                    </TooltipContent>
                  </Tooltip>
                </TabsList>
              </div>
              <TabsContent
                asChild
                value="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
                <DesktopKalender
                  view="arbeitsbereiche"
                  key="kalenderArbeitsbereiche"
                />
              </TabsContent>
              <TabsContent
                asChild
                value="mitarbeiter_rotationsplanKalenderByMitarbeiter">
                <DesktopKalender view="mitarbeiter" key="kalenderMitarbeiter" />
              </TabsContent>
            </div>
          </Tabs>
        </TabsContent>
        <TabsContent className="mt-4" value="uebersicht">
          <Suspense fallback={<>Loading</>}>
            <Uebersicht />
          </Suspense>
        </TabsContent>
      </Tabs>
      <Outlet />
    </div>
  );
}
